<script lang="ts" setup>
import { type ActivityIconTypeKR, type ActivityIconTypeUS, type ActivityType, getActivityOperation } from '@/api'
import $track from '@/track/webOfficialWebsite'
import { computed, onBeforeMount, ref, toRefs, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useLayout } from '~/store/layout'
import { SupportLocale } from '~/types/enum'
import KRActivity from './KRActivity.vue'
import USActivity from './USActivity.vue'
// TODO: BFActivity 组件糅合了多个活动运营位, 拆分出通用运营位与特殊运营位
import BFActivity from './XmasActivity.vue'

const { locale } = useI18n()
const { isMobile } = toRefs(useLayout())
const krActivityList = ref<ActivityIconTypeKR[]>([])
const usActivity = ref<ActivityIconTypeUS>({ banner: {}, list: [] })
const bfActivity = ref<ActivityType>({})
const template = ref('')
const userPageLanguageAllow = ref<SupportLocale | undefined>(undefined)
const isAllowLanguage = computed(() => {
  if (userPageLanguageAllow.value === undefined) return true
  return userPageLanguageAllow.value === locale.value
})

onBeforeMount(async () => {
  const { data, error } = await getActivityOperation(navigator.language, locale.value)
  if (data?.value?.values?.activity_operation?.template) {
    template.value = data?.value?.values?.activity_operation?.template
    userPageLanguageAllow.value = data?.value?.values?.activity_operation?.user_page_language_allow
    switch (template.value) {
      case 'KR':
        krActivityList.value =
          data?.value?.values?.activity_operation?.operation_gift?.[isMobile.value ? 'h5_icons' : 'icons']
        break
      case 'US':
        usActivity.value =
          data?.value?.values?.activity_operation?.operation_material?.[isMobile.value ? 'h5_material' : 'material']
        break
      case 'CHRISTMAS':
        if (data?.value?.values?.activity_operation?.operation_banner) {
          bfActivity.value = data?.value?.values?.activity_operation?.operation_banner
        }
        break
      default:
        // 通用活动 banner 位
        if (data?.value?.values?.activity_operation?.operation_banner) {
          bfActivity.value = data?.value?.values?.activity_operation?.operation_banner
        }
        break
    }
    if (error?.value) console.error(error.value)
  }
})
watch(template, (val: string) => {
  if (val) {
    $track.web_official_activity_banner_show({ template: val })
  }
})
</script>

<template>
  <USActivity
    v-if="template === 'US' && isAllowLanguage"
    :activity="usActivity"
  />
  <KRActivity
    v-if="template === 'KR' && isAllowLanguage"
    :activity-list="krActivityList"
  />
  <BFActivity
    v-if="bfActivity?.deepLink && isAllowLanguage"
    :activity="bfActivity"
  />
</template>
